import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PaperClipIcon } from 'assets/icons/paperClipAttachment.svg';
import { Attachment } from 'types';

import { MoreLink, ShowMore } from './styled';

interface EquipmentAttachmentsProps {
  attachments: Attachment[];
  onShowMore?: () => void;
}

export function EquipmentAttachments({
  attachments: attachmentsList,
  onShowMore,
}: EquipmentAttachmentsProps) {
  const { t } = useTranslation();

  function handleShowMore(e: SyntheticEvent) {
    e.stopPropagation();
    if (onShowMore) {
      onShowMore();
    }
  }

  if (!attachmentsList || attachmentsList.length === 0) {
    return null;
  }

  return (
    <>
      <ShowMore onClick={handleShowMore}>
        <PaperClipIcon style={{ width: 20, height: 20, flexShrink: 0 }} />
        <MoreLink>
          {attachmentsList.length} {t('equipments.moreAttachments')}
          {`${attachmentsList.length > 1 ? 's' : ''}`}
        </MoreLink>
      </ShowMore>
    </>
  );
}
